var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmedProcessingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.78947C0 0.801175 0.767343 0 1.71391 0L10.2834 0C11.23 0 11.9974 0.801175 11.9974 1.78947V8.05263H10.2834V1.78947H1.71391V15.2105H5.14172V17H1.71391C0.767343 17 0 16.1988 0 15.2105L0 1.78947Z",
    fill: "#303C42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6704 6.45023C18.044 6.75361 18.1113 7.31575 17.8208 7.70581L12.418 14.9584C11.7851 15.808 10.5822 15.8862 9.85326 15.1251L6.2549 11.3681C5.92024 11.0187 5.92024 10.4522 6.2549 10.1028C6.58956 9.75335 7.13216 9.75335 7.46682 10.1028L11.0652 13.8598L16.4679 6.60718C16.7584 6.21712 17.2968 6.14686 17.6704 6.45023Z",
    fill: "#303C42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedProcessingIcon);
export default __webpack_public_path__ + "static/media/ConfirmedProcessingIcon.46b7033786d63db41943b18f1b2078f9.svg";
export { ForwardRef as ReactComponent };